export default "__VITE_ASSET__BY75lmS2__"